"use strict";
var base_1 = require("@bhtp-client-api/base");
var PaymentInformation = (function () {
    function PaymentInformation() {
    }
    return PaymentInformation;
}());
exports.PaymentInformation = PaymentInformation;
var ApiPolicyGetForEditResponse = (function () {
    function ApiPolicyGetForEditResponse() {
    }
    ApiPolicyGetForEditResponse.createQuickQuoteRequestIncludeAllOptionalCoveragesInResponse = function (policyEditGetResponse) {
        var convertedResponseToRequest = new base_1.ApiQuoteRequest();
        var packageRequest = new base_1.ApiPackageRequest();
        var packageRequests = new Array();
        convertedResponseToRequest.policyNumber = policyEditGetResponse.policyNumber;
        convertedResponseToRequest.policy = policyEditGetResponse.policy;
        convertedResponseToRequest.flights = policyEditGetResponse.flights;
        convertedResponseToRequest.travelers = policyEditGetResponse.travelers;
        convertedResponseToRequest.policyBuyer = policyEditGetResponse.policyBuyer;
        // We want all coverages back so we are not going to set any.
        convertedResponseToRequest.coverages = null;
        packageRequest.optionalCoverages = null;
        // Set up package request
        packageRequest.ratingId = policyEditGetResponse.policy.packageRatingId;
        packageRequests.push(packageRequest);
        convertedResponseToRequest.selectedPackages = packageRequests;
        convertedResponseToRequest.quotablePackages = packageRequests;
        // Set quick quote to true,  no need to send acknowledgements as this is just a quick quote.
        convertedResponseToRequest.policy.isQuickQuote = true;
        return convertedResponseToRequest;
    };
    return ApiPolicyGetForEditResponse;
}());
exports.ApiPolicyGetForEditResponse = ApiPolicyGetForEditResponse;
//# sourceMappingURL=D:/a/1/s/edit/src/models/edit-policy-get-for-edit-response.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/edit/src/models/edit-policy-get-for-edit-response.model.js